"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const unitsPerTile = 10000;
exports.default = unitsPerTile;
